/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, ViewEncapsulation } from '@angular/core';
export class FormLabel {
constructor() {

    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'form-label',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormLabel_tsickle_Closure_declarations() {
/** @type {?} */
FormLabel.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormLabel.ctorParameters;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
